// extracted by mini-css-extract-plugin
module.exports = {"modal":"TU","modalContent":"UU","copy":"VU","modalBtnContainer":"WU","btnStay":"XU","disabled":"YU","btnContinue":"ZU"};